"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LoginPage = _interopRequireDefault(require("../LoginPage"));
var _RegisterPage = _interopRequireDefault(require("../RegisterPage"));
var _PasswordReset = _interopRequireDefault(require("../PasswordReset"));
var _Capture = _interopRequireDefault(require("../Capture/Capture"));
var _CheckoutConsents = _interopRequireDefault(require("../CheckoutConsents"));
var _OfferContainer = _interopRequireDefault(require("../../containers/OfferContainer"));
var _RedeemGift = _interopRequireDefault(require("../RedeemGift"));
var _ThankYouPage = _interopRequireDefault(require("../ThankYouPage"));
var _auth = _interopRequireDefault(require("../../services/auth"));
var _PasswordResetSuccess = _interopRequireDefault(require("../PasswordResetSuccess"));
var _appConfigHelper = require("../../util/appConfigHelper");
var _reactRedux = require("react-redux");
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CheckoutSteps = {
  LOGIN: {
    stepNumber: 0,
    nextStep: 2
  },
  REGISTER: {
    stepNumber: 1,
    nextStep: 2
  },
  CAPTURE: {
    stepNumber: 2,
    nextStep: 3
  },
  CONSENTS: {
    stepNumber: 3,
    nextStep: 4
  },
  PURCHASE: {
    stepNumber: 4,
    nextStep: 5
  },
  PASSWORD_SUCCESS: {
    stepNumber: 6,
    nextStep: 7
  },
  REDEEM_GIFT: {
    stepNumber: 8
  }
};
class Checkout extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "goToStep", step => {
      this.setState({
        currentStep: step
      });
    });
    this.state = {
      currentStep: 0,
      giftCode: ''
    };
  }
  componentDidMount() {
    const {
      initValues,
      offerId,
      adyenConfiguration
    } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const giftCodeParam = urlParams.get('giftCode');
    if (giftCodeParam) {
      this.setState({
        giftCode: giftCodeParam
      });
    }
    initValues({
      offerId,
      adyenConfiguration
    });
    if (_auth.default.isLogged()) {
      this.setState({
        currentStep: 3
      });
    }
  }
  render() {
    const {
      currentStep,
      giftCode
    } = this.state;
    const {
      couponCode,
      onSuccess,
      offerId,
      resetPasswordCallback
    } = this.props;
    switch (currentStep) {
      case 0:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginPage.default, {
          onSuccess: () => this.goToStep(CheckoutSteps.LOGIN.nextStep),
          onRegisterClick: () => this.goToStep(1),
          onPasswordResetClick: () => this.goToStep(6)
        });
      case 1:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RegisterPage.default, {
          onSuccess: () => this.goToStep(CheckoutSteps.REGISTER.nextStep),
          onHaveAccountClick: () => this.goToStep(0)
        });
      case 2:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Capture.default, {
          onSuccess: () => this.goToStep(CheckoutSteps.CAPTURE.nextStep)
        });
      case 3:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutConsents.default, {
          onSuccess: () => giftCode ? this.goToStep(CheckoutSteps.REDEEM_GIFT.stepNumber) : this.goToStep(CheckoutSteps.CONSENTS.nextStep)
        });
      case 4:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferContainer.default, {
          isCheckout: true,
          offerId: offerId,
          couponCode: couponCode,
          onSuccess: () => this.goToStep(CheckoutSteps.PURCHASE.nextStep),
          onRedeemClick: () => this.goToStep(CheckoutSteps.REDEEM_GIFT.stepNumber)
        });
      case 5:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThankYouPage.default, {
          onSuccess: onSuccess
        });
      case 6:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordReset.default, {
          onSuccess: () => this.goToStep(CheckoutSteps.PASSWORD_SUCCESS.nextStep)
        });
      case 7:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordResetSuccess.default, {
          email: (0, _appConfigHelper.getData)('CLEENG_CUSTOMER_EMAIL'),
          resetPasswordCallback: resetPasswordCallback
        });
      case 8:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedeemGift.default, {
          onBackClick: () => {
            this.goToStep(CheckoutSteps.PURCHASE.stepNumber);
          },
          onSuccess: onSuccess
        });
      default:
        return null;
    }
  }
}
Checkout.propTypes = {
  couponCode: _propTypes.default.string,
  offerId: _propTypes.default.string,
  onSuccess: _propTypes.default.func,
  resetPasswordCallback: _propTypes.default.func,
  adyenConfiguration: _propTypes.default.objectOf(_propTypes.default.any),
  initValues: _propTypes.default.func.isRequired
};
Checkout.defaultProps = {
  couponCode: null,
  offerId: null,
  onSuccess: () => null,
  resetPasswordCallback: () => null,
  adyenConfiguration: null
};
const mapDispatchToProps = dispatch => ({
  initValues: values => {
    dispatch((0, _publisherConfigSlice.init)(values));
  }
});
exports.mapDispatchToProps = mapDispatchToProps;
var _default = exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Checkout);